<script setup lang="ts">
import { tpgIconCheck, tpgIconError } from '@tpg/grammar-web-icons';
import { toTypedSchema } from '@vee-validate/yup';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';

import { GrammarTextField } from '@nora-monorepo/grammar-ui';
import { CONVERSATION_TITLE_MAX_LENGTH } from '@nora-monorepo/shared';

import { createConversationNameSchema } from '#ui-shared/validation/conversation-name.schema';

interface ConversationNameInputProps {
  name: string;
}

const props = defineProps<ConversationNameInputProps>();
const emit = defineEmits<{
  input: [];
}>();

const { t } = useI18n();

const { value, errorMessage, meta } = useField<string>(() => props.name, toTypedSchema(createConversationNameSchema(t)));

/** Updates the vee-validate field and lets parents know the user edited it. */
function onInput(newValue: string) {
  value.value = newValue;
  emit('input');
}
</script>

<template>
  <GrammarTextField
    :value="value"
    :label="t('conversation.conversationNameLabel')"
    :trailing-icon-template="meta.valid ? tpgIconCheck : tpgIconError"
    :form-associated="true"
    :counter="CONVERSATION_TITLE_MAX_LENGTH"
    :type="meta.valid ? 'default' : 'error'"
    :message="errorMessage"
    @change="value = $event"
    @input="onInput"
  />
</template>
